import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.modalId = '#modal-swap-professor-commission';

    $(this.modalId).modal('show');
    $(this.element.querySelector('.select2')).select2();
  }

  disconnect() {
    $(this.modalId).modal('dispose');
  }
}